export default __webpack_public_path__ + "static/media/TD50_1.7f9fef4e.jpg";